import React from "react";

import "./styles.scss";

export default function Emergence() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            id="freepik_stories-emergency-call"
            className="animated"
            version="1.1"
            viewBox="0 0 500 500"
        >
            <g
                id="freepik--background-complete--inject-274"
                style={{
                    WebkitTransformOrigin: 248.769,
                    MsTransformOrigin: 248.769,
                    transformOrigin: 248.769,
                }}
                className="animable animator-hidden"
            >
                <path
                    style={{
                        WebkitTransformOrigin: 354.78,
                        MsTransformOrigin: 354.78,
                        transformOrigin: 354.78,
                    }}
                    id="el4hnlxqga4ot"
                    fill="#E0E0E0"
                    d="M298.59 41.23H410.96999999999997V158.38H298.59z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 347.17,
                        MsTransformOrigin: 347.17,
                        transformOrigin: 347.17,
                    }}
                    id="elnzirdlif2zi"
                    fill="#FAFAFA"
                    d="M290.98 41.23H403.36V158.38H290.98z"
                    className="animable"
                ></path>
                <path
                    d="M403.39 158.41H290.94V41.19h112.45zM291 158.34h112.32V41.26H291z"
                    style={{
                        WebkitTransformOrigin: 347.165,
                        MsTransformOrigin: 347.165,
                        transformOrigin: 347.165,
                    }}
                    id="el9vn7gfxkl1m"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 347.165,
                        MsTransformOrigin: 347.165,
                        transformOrigin: 347.165,
                    }}
                    id="elclsvw36k8z9"
                    fill="#FFF"
                    d="M306.08 56.98H388.25V142.63H306.08z"
                    className="animable"
                ></path>
                <path
                    d="M306.08 143.2a13.26 13.26 0 01-2 2.36c-1.31 1.38-3.15 3.25-5.22 5.29s-4 3.85-5.37 5.14a13.18 13.18 0 01-2.37 2 12.67 12.67 0 012-2.35c1.31-1.39 3.16-3.26 5.23-5.31s4-3.86 5.38-5.14a12.84 12.84 0 012.35-1.99z"
                    style={{
                        WebkitTransformOrigin: 298.6,
                        MsTransformOrigin: 298.6,
                        transformOrigin: 298.6,
                    }}
                    id="el4um46z5gw8j"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M388.25 143a12.86 12.86 0 012.36 2c1.38 1.31 3.26 3.15 5.29 5.22s3.85 4 5.14 5.37a13.18 13.18 0 012 2.37 12.67 12.67 0 01-2.35-2c-1.38-1.31-3.26-3.16-5.31-5.23s-3.86-4-5.14-5.38a12.84 12.84 0 01-1.99-2.35z"
                    style={{
                        WebkitTransformOrigin: 395.645,
                        MsTransformOrigin: 395.645,
                        transformOrigin: 395.645,
                    }}
                    id="eli9jiy3nad4p"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M388 57.21a13.51 13.51 0 012-2.36c1.31-1.39 3.16-3.26 5.22-5.3s4-3.85 5.37-5.13a13 13 0 012.38-2 13.38 13.38 0 01-2 2.34c-1.31 1.39-3.16 3.27-5.23 5.31s-4 3.86-5.38 5.15a12.8 12.8 0 01-2.36 1.99z"
                    style={{
                        WebkitTransformOrigin: 395.485,
                        MsTransformOrigin: 395.485,
                        transformOrigin: 395.485,
                    }}
                    id="elm92ba4xfdbe"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M305.86 57.42a13.51 13.51 0 01-2.36-2c-1.38-1.31-3.26-3.16-5.29-5.22s-3.86-4-5.14-5.37a13 13 0 01-2-2.38 13.62 13.62 0 012.35 2c1.38 1.31 3.26 3.16 5.3 5.23s3.86 4 5.15 5.38a12.8 12.8 0 011.99 2.36z"
                    style={{
                        WebkitTransformOrigin: 298.465,
                        MsTransformOrigin: 298.465,
                        transformOrigin: 298.465,
                    }}
                    id="el5ldg5c0gug9"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M388 142.63v-.42-1.19-4.63c0-4-.05-10-.08-17.45 0-15-.1-36.37-.16-62l.31.31-81.93.05.37-.36c0 31.43 0 60.85-.05 85.65l-.32-.31 59.33.16 16.67.08H388.08h-5.81l-16.6.08-59.53.16h-.31v-.31V56.43h82.62V57c-.07 25.67-.12 47.11-.16 62.16 0 7.46-.06 13.34-.08 17.38v5.73a1.52 1.52 0 01-.21.36z"
                    style={{
                        WebkitTransformOrigin: 347.14,
                        MsTransformOrigin: 347.14,
                        transformOrigin: 347.14,
                    }}
                    id="elr9j4buah3l"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 347.17,
                        MsTransformOrigin: 347.17,
                        transformOrigin: 347.17,
                    }}
                    id="ellgtgk4odfcn"
                    fill="#EBEBEB"
                    d="M333.46 86.09H360.88V113.51H333.46z"
                    className="animable"
                ></path>
                <path
                    d="M430.11 351c6.12-3.16 13.34-3.57 20.14-2.45 3.65.6 7.46 1.7 9.95 4.44s2.95 7.58.1 9.94c-1.7 1.4-4.07 1.61-6.27 1.59-5.33-.07-11.24-1-15.49 2.2-2.43 1.83-4 4.87-6.94 5.77s-6-.8-7.55-3.36a11.66 11.66 0 01-.85-8.65 13.21 13.21 0 016.91-9.48z"
                    style={{
                        WebkitTransformOrigin: 442.496,
                        MsTransformOrigin: 442.496,
                        transformOrigin: 442.496,
                    }}
                    id="eluk2s8rs06s8"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M416.07 323.87c3.75 5.35 11 3.58 14.4.32s4.81-8 6.1-12.52c3-10.31 6-21.13 3.76-31.63a17.64 17.64 0 00-4-8.6c-2.21-2.33-5.6-3.72-8.7-2.9-3.67 1-6 4.57-7.6 8a75.39 75.39 0 00-7.46 32.36c0 5.21.6 10.68 3.54 15"
                    style={{
                        WebkitTransformOrigin: 426.84,
                        MsTransformOrigin: 426.84,
                        transformOrigin: 426.84,
                    }}
                    id="elnxdyohsd2t"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M405 347.05c4.07-4.83 4.84-11.87 3-17.92s-5.9-11.19-10.61-15.39a57.24 57.24 0 00-19-11.21 20.17 20.17 0 00-8.55-1.45 9 9 0 00-7.17 4.34c-2 3.81-.08 8.44 2 12.21a146.81 146.81 0 0012.48 19c3.75 4.82 8 9.58 13.73 11.76s11.62 1.92 14.65-2"
                    style={{
                        WebkitTransformOrigin: 385.386,
                        MsTransformOrigin: 385.386,
                        transformOrigin: 385.386,
                    }}
                    id="elod6g0xmop2k"
                    fill="#EBEBEB"
                    className="animable"
                ></path>
                <path
                    d="M415.82 404.58a11.91 11.91 0 00.34-2.43c.17-1.77.38-4 .64-6.63a97.48 97.48 0 011.49-9.74 76.41 76.41 0 013.54-11.48 42.16 42.16 0 015.87-10.4 21.89 21.89 0 017.41-6.16 20.55 20.55 0 016.25-1.94 11.17 11.17 0 002.42-.36 12.05 12.05 0 00-2.47 0 18.82 18.82 0 00-6.51 1.69 22 22 0 00-7.82 6.22 41.48 41.48 0 00-6.08 10.6 70.5 70.5 0 00-3.51 11.68 83.65 83.65 0 00-1.3 9.85c-.21 2.82-.29 5.1-.32 6.68a10.89 10.89 0 00.05 2.42z"
                    style={{
                        WebkitTransformOrigin: 429.753,
                        MsTransformOrigin: 429.753,
                        transformOrigin: 429.753,
                    }}
                    id="ellgzo0hdnsod"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M416.27 399.48a4.32 4.32 0 00.07-1.13v-3.23c0-2.8 0-6.85.14-11.85.25-10 1.11-20.78 2.78-36 1.57-14.27 3.69-30.89 5.92-41.69.48-2.45 1-4.67 1.41-6.6s.81-3.61 1.16-5l.76-3.13a4.22 4.22 0 00.19-1.12 5.65 5.65 0 00-.39 1.06q-.36 1.22-.93 3.09c-.42 1.34-.84 3-1.33 4.94s-1 4.13-1.56 6.58a365.71 365.71 0 00-6.23 38.69c-1.67 15.21-2.42 29.06-2.48 39.1-.06 5 0 9.07.17 11.87.08 1.31.15 2.38.2 3.23a5.07 5.07 0 00.12 1.19z"
                    style={{
                        WebkitTransformOrigin: 422.229,
                        MsTransformOrigin: 422.229,
                        transformOrigin: 422.229,
                    }}
                    id="el161adnm3kt8"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    d="M415.54 388.26a21.21 21.21 0 000-3.37c-.13-2.17-.42-5.3-1-9.13a121 121 0 00-3-13.3 108.9 108.9 0 00-5.54-15.74c-4.61-11-10.88-19.9-16.33-25.44a43 43 0 00-3.84-3.57c-.59-.5-1.12-1-1.65-1.39l-1.49-1a22.16 22.16 0 00-2.83-1.81c-.17.22 4 2.68 9.29 8.29A88.19 88.19 0 01405 347.12a125.56 125.56 0 015.6 15.59c1.46 4.89 2.42 9.38 3.16 13.17s1.09 6.9 1.34 9a21.92 21.92 0 00.44 3.38z"
                    style={{
                        WebkitTransformOrigin: 397.731,
                        MsTransformOrigin: 397.731,
                        transformOrigin: 397.731,
                    }}
                    id="elyflc4xsa3r"
                    fill="#E0E0E0"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 416.755,
                        MsTransformOrigin: 416.755,
                        transformOrigin: 416.755,
                    }}
                    id="ellmitsmr9ffj"
                    fill="#E0E0E0"
                    d="M390.52 419.89L393.19 456.57 440.31 456.57 442.99 419.89 390.52 419.89z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 417.29,
                        MsTransformOrigin: 417.29,
                        transformOrigin: 417.29,
                    }}
                    id="elt3q0x2ityga"
                    fill="#E0E0E0"
                    d="M385.97 405.43H448.61V419.89H385.97z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 416.775,
                        MsTransformOrigin: 416.775,
                        transformOrigin: 416.775,
                    }}
                    id="elavtmo1wlnoc"
                    fill="#EBEBEB"
                    d="M385.97 455.16L385.97 459.17 388.91 459.17 447.58 459.17 447.58 455.16 385.97 455.16z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 417.12,
                        MsTransformOrigin: 417.12,
                        transformOrigin: 417.12,
                    }}
                    id="elgicr2fxk5v7"
                    fill="#E0E0E0"
                    d="M391.8 466.22L388.91 459.17 445.33 459.17 441.97 466.22 391.8 466.22z"
                    className="animable"
                ></path>
                <path
                    d="M442.11 431.88s-.06.12-.21.33l-.71.94-2.74 3.51-.13.16-.11-.17-6.75-9.32h.39l-6.64 9.4-.21.27-.23-.28-7.87-9.36h.45l-.43.54-7 8.83-.24.29-.21-.3-6.65-9.4h.39l-8.21 9.35-.15.16-.11-.18-2.56-4.31c-.27-.46-.48-.84-.66-1.14a2.13 2.13 0 01-.2-.41s.11.12.28.36l.73 1.11 2.68 4.22h-.25c2.09-2.46 4.83-5.66 8.05-9.43l.2-.24.18.25 6.71 9.36h-.46l7-8.84c.15-.19.3-.37.43-.55l.23-.28.23.28 7.85 9.39h-.44c2.42-3.38 4.68-6.52 6.7-9.35l.2-.28.19.28c2.66 3.79 4.91 7 6.6 9.43h-.24l2.86-3.42.76-.89c.19-.19.29-.32.3-.31z"
                    style={{
                        WebkitTransformOrigin: 416.715,
                        MsTransformOrigin: 416.715,
                        transformOrigin: 416.715,
                    }}
                    id="elrfiswuojw"
                    fill="#F5F5F5"
                    className="animable"
                ></path>
                <path
                    d="M443.65 419.65c0 .16-11.81.29-26.37.29s-26.37-.13-26.37-.29 11.8-.3 26.37-.3 26.37.13 26.37.3z"
                    style={{
                        WebkitTransformOrigin: 417.28,
                        MsTransformOrigin: 417.28,
                        transformOrigin: 417.28,
                    }}
                    id="elg9w7o3b9jt"
                    fill="#F5F5F5"
                    className="animable"
                ></path>
                <path
                    d="M446 459.56c0 .17-12.84.3-28.66.3s-28.66-.13-28.66-.3 12.83-.29 28.66-.29 28.66.13 28.66.29z"
                    style={{
                        WebkitTransformOrigin: 417.34,
                        MsTransformOrigin: 417.34,
                        transformOrigin: 417.34,
                    }}
                    id="eljhzapi98oc9"
                    fill="#F5F5F5"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 107.87,
                        MsTransformOrigin: 107.87,
                        transformOrigin: 107.87,
                    }}
                    id="elcekkeykc50v"
                    fill="#F5F5F5"
                    d="M40.9 422.35L40.9 465.9 104.59 465.9 174.84 465.9 174.84 422.35 40.9 422.35z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 107.4,
                        MsTransformOrigin: 107.4,
                        transformOrigin: 107.4,
                    }}
                    id="elsh2kiukrnb8"
                    fill="#E0E0E0"
                    d="M35.28 410.18L35.28 422.35 179.52 422.35 179.52 410.18 104.59 410.18 35.28 410.18z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 142.055,
                        MsTransformOrigin: 142.055,
                        transformOrigin: 142.055,
                    }}
                    id="elox6v7qj7ja"
                    fill="#E0E0E0"
                    d="M107.4 465.9L174.84 465.9 174.84 422.35 179.52 422.35 179.52 410.18 104.59 410.18 104.59 421.23 107.4 465.9z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 73.21,
                        MsTransformOrigin: 73.21,
                        transformOrigin: 73.21,
                    }}
                    id="el66nfti5hfn"
                    fill="#E0E0E0"
                    d="M59.63 429.38H86.79V435.94H59.63z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 73.58,
                        MsTransformOrigin: 73.58,
                        transformOrigin: 73.58,
                    }}
                    id="elt92fia105g"
                    fill="#FFF"
                    d="M56.14 444.13H91.02000000000001V457.96999999999997H56.14z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 128.475,
                        MsTransformOrigin: 128.475,
                        transformOrigin: 128.475,
                    }}
                    id="elk9ers74w9ob"
                    fill="#F5F5F5"
                    d="M61.51 366.68L61.51 410.23 125.19 410.23 195.44 410.23 195.44 366.68 61.51 366.68z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 128.01,
                        MsTransformOrigin: 128.01,
                        transformOrigin: 128.01,
                    }}
                    id="eltygh8019v"
                    fill="#E0E0E0"
                    d="M55.89 354.5L55.89 366.68 200.13 366.68 200.13 354.5 125.19 354.5 55.89 354.5z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 162.66,
                        MsTransformOrigin: 162.66,
                        transformOrigin: 162.66,
                    }}
                    id="el6mmtd8bv667"
                    fill="#E0E0E0"
                    d="M128 410.23L195.44 410.23 195.44 366.68 200.13 366.68 200.13 354.5 125.19 354.5 125.19 365.55 128 410.23z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 93.82,
                        MsTransformOrigin: 93.82,
                        transformOrigin: 93.82,
                    }}
                    id="elogi7re7eo6"
                    fill="#E0E0E0"
                    d="M80.24 373.7H107.39999999999999V380.26H80.24z"
                    className="animable"
                ></path>
                <path
                    style={{
                        WebkitTransformOrigin: 94.18,
                        MsTransformOrigin: 94.18,
                        transformOrigin: 94.18,
                    }}
                    id="el90d8g2xfaa8"
                    fill="#FFF"
                    d="M76.74 388.46H111.62V402.29999999999995H76.74z"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--Table--inject-274"
                style={{
                    WebkitTransformOrigin: 250,
                    MsTransformOrigin: 250,
                    transformOrigin: 250,
                }}
                className="animable animator-active animator-hidden"
            >
                <path
                    d="M476.87 466.22c0 .15-101.58.26-226.86.26s-226.88-.11-226.88-.26S124.69 466 250 466s226.87.08 226.87.22z"
                    style={{
                        WebkitTransformOrigin: 250,
                        MsTransformOrigin: 250,
                        transformOrigin: 250,
                    }}
                    id="el1yr8qucjivy"
                    fill="#263238"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--Device--inject-274"
                style={{
                    WebkitTransformOrigin: 140.709,
                    MsTransformOrigin: 140.709,
                    transformOrigin: 140.709,
                }}
                className="animable"
            >
                <path
                    d="M199.65 389.42l-117-.06a25.27 25.27 0 01-25.48-25.05V76.14a25.27 25.27 0 0125.51-25l117 .07c14.08 0 25.48 11.22 24.51 25l-.06 288.17c1.02 13.84-10.4 25.05-24.48 25.04z"
                    style={{
                        WebkitTransformOrigin: 140.709,
                        MsTransformOrigin: 140.709,
                        transformOrigin: 140.709,
                    }}
                    id="elaav2xzbsi1"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M199.79 59.42H177.1a5.64 5.64 0 00-5.51 5.76v4.11a5.64 5.64 0 01-5.51 5.71h-44.23a5.63 5.63 0 01-5.5-5.76v-4.11a5.64 5.64 0 00-5.51-5.76H83a17.86 17.86 0 00-17.87 17.84v286.37a17.85 17.85 0 0017.84 17.86l116.8.07a17.86 17.86 0 0017.86-17.85l.06-286.38a17.86 17.86 0 00-17.9-17.86z"
                    style={{
                        WebkitTransformOrigin: 141.41,
                        MsTransformOrigin: 141.41,
                        transformOrigin: 141.41,
                    }}
                    id="eltzotm3x509"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M206.47 92.39c0 .08-3.15.17-7 .2s-7 0-7-.09 3.15-.17 7-.2 7 .01 7 .09z"
                    style={{
                        WebkitTransformOrigin: 199.47,
                        MsTransformOrigin: 199.47,
                        transformOrigin: 199.47,
                    }}
                    id="elyjy2ae6tf9"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M206.5 96c0 .08-3.15.17-7 .2s-7 0-7-.09 3.15-.17 7-.2 7-.01 7 .09z"
                    style={{
                        WebkitTransformOrigin: 199.5,
                        MsTransformOrigin: 199.5,
                        transformOrigin: 199.5,
                    }}
                    id="el4dd64hwajj7"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M206.53 99.59c0 .08-3.15.17-7 .2s-7 0-7-.09 3.15-.17 7-.2 7 0 7 .09z"
                    style={{
                        WebkitTransformOrigin: 199.53,
                        MsTransformOrigin: 199.53,
                        transformOrigin: 199.53,
                    }}
                    id="eljbw5rpprvw"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M78.56 103.81h1.11l3-.08-.08.09v-2.18-1.25a1.16 1.16 0 011-.93h1.43a1.18 1.18 0 011 1.16v3.18l-.14-.14h3.79l-.14.15v-4.72-1.2a1.26 1.26 0 00-.54-.9l-1.65-1.63-1.6-1.58-.78-.76a1.78 1.78 0 00-.78-.59 1 1 0 00-.87.17c-.23.19-.47.47-.7.69l-1.41 1.28c-.86.89-1.75 1.7-2.4 2.47a2.7 2.7 0 00-.19 1.41v4.87a2.86 2.86 0 010 .49v-.45V102v-2.17-1.36-.74a1.58 1.58 0 01.21-.79c.7-.86 1.54-1.62 2.4-2.54l1.15-1.4a10 10 0 01.73-.72 1.27 1.27 0 011.1-.22 2.05 2.05 0 01.91.65l.78.76 1.6 1.57 1.66 1.63a3.2 3.2 0 01.42.46 1.13 1.13 0 01.2.64V103.84H85.7v-.14-3.17a.9.9 0 00-.77-.92h-1.37a.94.94 0 00-.82.74V103.82H78.85z"
                    style={{
                        WebkitTransformOrigin: 84.165,
                        MsTransformOrigin: 84.165,
                        transformOrigin: 84.165,
                    }}
                    id="elbzyt98ct9uf"
                    fill="#FFF"
                    className="animable"
                ></path>
                <circle
                    cx="148.44"
                    cy="319.14"
                    r="21.75"
                    style={{
                        WebkitTransformOrigin: 148.44,
                        MsTransformOrigin: 148.44,
                        transformOrigin: 148.44,
                    }}
                    id="elhi6dyqb62a"
                    fill="#FFF"
                    className="animable"
                ></circle>
                <path
                    d="M135.1 324.14l5.43-1.28a1.47 1.47 0 001.14-1.44v-1.12s-.23-1.9 1.57-2c1.28-.09 9.45 0 9.45 0s2.15 0 2.12 1.65v1.63a1.28 1.28 0 00.9 1.22l5.89 1.78a1.27 1.27 0 001.54-.73l.75-1.82a2.36 2.36 0 00.19-1.05 5 5 0 00-1-2.72c-1.17-1.5-6.68-5-17.18-4.53-10 .48-12.18 4.7-12.75 5.71a4.25 4.25 0 00-.19 2.81l.44 1a1.48 1.48 0 001.7.89z"
                    style={{
                        WebkitTransformOrigin: 148.444,
                        MsTransformOrigin: 148.444,
                        transformOrigin: 148.444,
                    }}
                    id="elyma033nuit"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 148.44,
                        MsTransformOrigin: 148.44,
                        transformOrigin: 148.44,
                    }}
                    id="eljp8f61xhzyo"
                    className="animable"
                    opacity="0.2"
                >
                    <circle
                        cx="148.44"
                        cy="249.44"
                        r="15.07"
                        style={{
                            WebkitTransformOrigin: 148.44,
                            MsTransformOrigin: 148.44,
                            transformOrigin: 148.44,
                        }}
                        id="elsixuouwhb1j"
                        fill="#FFF"
                        className="animable"
                    ></circle>
                </g>
                <circle
                    cx="144.32"
                    cy="249.46"
                    r="1.75"
                    style={{
                        WebkitTransformOrigin: 144.32,
                        MsTransformOrigin: 144.32,
                        transformOrigin: 144.32,
                    }}
                    id="eljs0c9jomklo"
                    fill="#FFF"
                    className="animable"
                ></circle>
                <path
                    d="M150.19 249.46a1.75 1.75 0 11-1.75-1.75 1.75 1.75 0 011.75 1.75z"
                    style={{
                        WebkitTransformOrigin: 148.44,
                        MsTransformOrigin: 148.44,
                        transformOrigin: 148.44,
                    }}
                    id="elwqn8zm5lm2j"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M154.31 249.46a1.76 1.76 0 11-1.75-1.75 1.75 1.75 0 011.75 1.75z"
                    style={{
                        WebkitTransformOrigin: 152.55,
                        MsTransformOrigin: 152.55,
                        transformOrigin: 152.55,
                    }}
                    id="elv1kb9zye34h"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M146.07 245.28a1.75 1.75 0 11-1.75-1.76 1.75 1.75 0 011.75 1.76z"
                    style={{
                        WebkitTransformOrigin: 144.32,
                        MsTransformOrigin: 144.32,
                        transformOrigin: 144.32,
                    }}
                    id="el3ghsn5izhjm"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M150.19 245.28a1.75 1.75 0 11-1.75-1.76 1.75 1.75 0 011.75 1.76z"
                    style={{
                        WebkitTransformOrigin: 148.44,
                        MsTransformOrigin: 148.44,
                        transformOrigin: 148.44,
                    }}
                    id="elqgwucfztl3n"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M154.31 245.28a1.76 1.76 0 11-1.75-1.76 1.75 1.75 0 011.75 1.76z"
                    style={{
                        WebkitTransformOrigin: 152.55,
                        MsTransformOrigin: 152.55,
                        transformOrigin: 152.55,
                    }}
                    id="elq6ilbj9pbrs"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M146.07 253.6a1.75 1.75 0 11-1.75-1.75 1.75 1.75 0 011.75 1.75z"
                    style={{
                        WebkitTransformOrigin: 144.32,
                        MsTransformOrigin: 144.32,
                        transformOrigin: 144.32,
                    }}
                    id="el8xd2c9bdzwk"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M150.19 253.6a1.75 1.75 0 11-1.75-1.75 1.75 1.75 0 011.75 1.75z"
                    style={{
                        WebkitTransformOrigin: 148.44,
                        MsTransformOrigin: 148.44,
                        transformOrigin: 148.44,
                    }}
                    id="elxqo8f2hv2yj"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M154.31 253.6a1.76 1.76 0 11-1.75-1.75 1.75 1.75 0 011.75 1.75z"
                    style={{
                        WebkitTransformOrigin: 152.55,
                        MsTransformOrigin: 152.55,
                        transformOrigin: 152.55,
                    }}
                    id="ellb0wdpu9tep"
                    fill="#FFF"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 105.18,
                        MsTransformOrigin: 105.18,
                        transformOrigin: 105.18,
                    }}
                    id="el9esuuos0wuu"
                    className="animable"
                    opacity="0.2"
                >
                    <circle
                        cx="105.18"
                        cy="249.44"
                        r="15.07"
                        style={{
                            WebkitTransformOrigin: 105.18,
                            MsTransformOrigin: 105.18,
                            transformOrigin: 105.18,
                        }}
                        id="elobolvljhay"
                        fill="#FFF"
                        className="animable"
                    ></circle>
                </g>
                <path
                    d="M98.11 247.47V251a.27.27 0 00.27.27h2a.27.27 0 01.17.06l3.07 2.4a.27.27 0 00.44-.22v-8.33a.27.27 0 00-.43-.23l-3 2.14a.33.33 0 01-.16.05h-2.09a.28.28 0 00-.27.33z"
                    style={{
                        WebkitTransformOrigin: 101.083,
                        MsTransformOrigin: 101.083,
                        transformOrigin: 101.083,
                    }}
                    id="elinl82akkse"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M109.74 255.46a.33.33 0 01-.23-.09.34.34 0 010-.48 8.14 8.14 0 002.39-5.89 8 8 0 00-2.39-5 .35.35 0 11.46-.52 8.55 8.55 0 012.62 5.47 8.82 8.82 0 01-2.59 6.38.38.38 0 01-.26.13z"
                    style={{
                        WebkitTransformOrigin: 110.974,
                        MsTransformOrigin: 110.974,
                        transformOrigin: 110.974,
                    }}
                    id="eli1nyb53b2h"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M107.84 253.78a.34.34 0 01-.25-.11.35.35 0 010-.49 5 5 0 001.84-3.69 6.23 6.23 0 00-1.84-4 .35.35 0 010-.49.34.34 0 01.48 0 6.83 6.83 0 012.06 4.51 5.69 5.69 0 01-2.06 4.2.3.3 0 01-.23.07z"
                    style={{
                        WebkitTransformOrigin: 108.81,
                        MsTransformOrigin: 108.81,
                        transformOrigin: 108.81,
                    }}
                    id="el2fqlley3s0m"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M106.15 252a.37.37 0 01-.24-.1.34.34 0 010-.49c2.12-2.1.07-4.48 0-4.58a.36.36 0 010-.49.35.35 0 01.49 0s2.57 3 0 5.53a.35.35 0 01-.25.13z"
                    style={{
                        WebkitTransformOrigin: 106.674,
                        MsTransformOrigin: 106.674,
                        transformOrigin: 106.674,
                    }}
                    id="ely4ijv2maq7"
                    fill="#FFF"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 187.99,
                        MsTransformOrigin: 187.99,
                        transformOrigin: 187.99,
                    }}
                    id="el5t754n2k127"
                    className="animable"
                    opacity="0.2"
                >
                    <circle
                        cx="187.99"
                        cy="249.44"
                        r="15.07"
                        style={{
                            WebkitTransformOrigin: 187.99,
                            MsTransformOrigin: 187.99,
                            transformOrigin: 187.99,
                        }}
                        id="eloegz9g4y0ua"
                        fill="#FFF"
                        className="animable"
                    ></circle>
                </g>
                <path
                    d="M188.09 254.65a.47.47 0 01-.47-.46v-9.5a.47.47 0 01.93 0v9.5a.47.47 0 01-.46.46z"
                    style={{
                        WebkitTransformOrigin: 188.085,
                        MsTransformOrigin: 188.085,
                        transformOrigin: 188.085,
                    }}
                    id="el3qrntdgrf6r"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M192.6 249.9h-9.21a.47.47 0 01-.47-.46.46.46 0 01.47-.46h9.21a.45.45 0 01.46.46.46.46 0 01-.46.46z"
                    style={{
                        WebkitTransformOrigin: 187.99,
                        MsTransformOrigin: 187.99,
                        transformOrigin: 187.99,
                    }}
                    id="eluqjn2knqsu"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M129.68 147.85q6.18 6.66 6.18 19.17a32.39 32.39 0 01-3.31 15.2 22.52 22.52 0 01-9.35 9.6 28.63 28.63 0 01-13.92 3.28 33.4 33.4 0 01-8-.93 21.29 21.29 0 01-6.48-2.65l4.47-8.86a16.85 16.85 0 009.75 2.61q6.63 0 10.5-3.91t4.17-11.28q-4.68 4.69-13 4.69a20.35 20.35 0 01-9.09-2 15.87 15.87 0 01-6.48-5.7 15.34 15.34 0 01-2.38-8.52 16.21 16.21 0 012.61-9.16 16.82 16.82 0 017.11-6.07 23.11 23.11 0 0110-2.13q11.04-.01 17.22 6.66zm-9.79 15.71a7.63 7.63 0 00.07-11.21 9.63 9.63 0 00-6.66-2.16 9.29 9.29 0 00-6.29 2.09 7.07 7.07 0 00-2.42 5.66 7.19 7.19 0 002.42 5.7 10.68 10.68 0 0012.88-.08z"
                    style={{
                        WebkitTransformOrigin: 114.305,
                        MsTransformOrigin: 114.305,
                        transformOrigin: 114.305,
                    }}
                    id="elvz2cy4k2tmk"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M161.33 142.08v52.13h-12.06v-42.45h-10.43v-9.68z"
                    style={{
                        WebkitTransformOrigin: 150.085,
                        MsTransformOrigin: 150.085,
                        transformOrigin: 150.085,
                    }}
                    id="elzt2k4ql903q"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M190.52 142.08v52.13h-12.06v-42.45H168v-9.68z"
                    style={{
                        WebkitTransformOrigin: 179.26,
                        MsTransformOrigin: 179.26,
                        transformOrigin: 179.26,
                    }}
                    id="el3a5d07jvte"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M96.71 215.22V217h-6.46v-8h6.31v1.76H92.5v1.36h3.58v1.7H92.5v1.47z"
                    style={{
                        WebkitTransformOrigin: 93.48,
                        MsTransformOrigin: 93.48,
                        transformOrigin: 93.48,
                    }}
                    id="elexlmtnf63fi"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M105.25 217v-4.27l-2.07 3.48h-1l-2.06-3.36V217H98v-8h1.87l2.83 4.65 2.76-4.65h1.88v8z"
                    style={{
                        WebkitTransformOrigin: 102.67,
                        MsTransformOrigin: 102.67,
                        transformOrigin: 102.67,
                    }}
                    id="elu2rgvhw83uj"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M115.42 215.22V217H109v-8h6.32v1.76h-4.06v1.36h3.57v1.7h-3.57v1.47z"
                    style={{
                        WebkitTransformOrigin: 112.21,
                        MsTransformOrigin: 112.21,
                        transformOrigin: 112.21,
                    }}
                    id="elfgmfmxpluwd"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M120.2 214.84H119V217h-2.28v-8h3.68a4.63 4.63 0 011.9.36 2.77 2.77 0 011.24 1 2.84 2.84 0 01.44 1.58 2.81 2.81 0 01-.41 1.52 2.66 2.66 0 01-1.17 1l1.7 2.54h-2.44zm1.08-3.8a1.54 1.54 0 00-1.06-.32H119v2.36h1.26a1.6 1.6 0 001.06-.3 1.08 1.08 0 00.36-.87 1.07 1.07 0 00-.4-.91z"
                    style={{
                        WebkitTransformOrigin: 120.41,
                        MsTransformOrigin: 120.41,
                        transformOrigin: 120.41,
                    }}
                    id="elhdau7z6pmd"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M130.59 212.78h2v3.34a5.32 5.32 0 01-1.59.76 6.46 6.46 0 01-1.79.26 4.91 4.91 0 01-2.28-.53 4.07 4.07 0 01-1.59-1.49 4.4 4.4 0 010-4.33 4.11 4.11 0 011.6-1.49 5 5 0 012.32-.53 5.19 5.19 0 012 .38 3.93 3.93 0 011.5 1.09l-1.45 1.31a2.56 2.56 0 00-2-.89 2.15 2.15 0 00-2.3 2.3 2.47 2.47 0 00.29 1.19 2 2 0 00.8.81 2.34 2.34 0 001.19.3 2.87 2.87 0 001.23-.27z"
                    style={{
                        WebkitTransformOrigin: 128.765,
                        MsTransformOrigin: 128.765,
                        transformOrigin: 128.765,
                    }}
                    id="el2za8mux7z9d"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M140.51 215.22V217h-6.46v-8h6.32v1.76h-4.07v1.36h3.58v1.7h-3.58v1.47z"
                    style={{
                        WebkitTransformOrigin: 137.28,
                        MsTransformOrigin: 137.28,
                        transformOrigin: 137.28,
                    }}
                    id="ellnunaf8a19r"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M149.44 208.93v8h-1.87l-3.57-4.24V217h-2.23v-8h1.87l3.56 4.29V209z"
                    style={{
                        WebkitTransformOrigin: 145.605,
                        MsTransformOrigin: 145.605,
                        transformOrigin: 145.605,
                    }}
                    id="ell6rnoprxbv7"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M152.79 216.61a4 4 0 01-1.58-1.49 4.14 4.14 0 011.58-5.82 4.84 4.84 0 012.27-.53 5 5 0 012 .39 3.82 3.82 0 011.47 1.13l-1.45 1.31a2.38 2.38 0 00-1.9-.94 2.36 2.36 0 00-1.17.28 2.05 2.05 0 00-.79.81 2.73 2.73 0 000 2.41 2 2 0 00.79.81 2.36 2.36 0 001.17.29 2.39 2.39 0 001.9-.95l1.45 1.31a3.73 3.73 0 01-1.47 1.13 5 5 0 01-2 .39 4.84 4.84 0 01-2.27-.53z"
                    style={{
                        WebkitTransformOrigin: 154.564,
                        MsTransformOrigin: 154.564,
                        transformOrigin: 154.564,
                    }}
                    id="elsb0bafoe76"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M163.82 214.09V217h-2.28v-2.92l-3.07-5.13h2.4l1.91 3.2 1.91-3.2h2.21z"
                    style={{
                        WebkitTransformOrigin: 162.685,
                        MsTransformOrigin: 162.685,
                        transformOrigin: 162.685,
                    }}
                    id="elk0mduwf846"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M172.57 216.61a4 4 0 01-1.59-1.49 4.4 4.4 0 010-4.33 4.08 4.08 0 011.59-1.49 4.81 4.81 0 012.27-.53 4.91 4.91 0 012 .39 3.82 3.82 0 011.47 1.13l-1.45 1.31a2.37 2.37 0 00-1.9-.94 2.41 2.41 0 00-1.17.28 2.05 2.05 0 00-.79.81 2.73 2.73 0 000 2.41 2 2 0 00.79.81 2.42 2.42 0 001.17.29 2.38 2.38 0 001.9-.95l1.45 1.31a3.73 3.73 0 01-1.47 1.13 4.91 4.91 0 01-2 .39 4.81 4.81 0 01-2.27-.53z"
                    style={{
                        WebkitTransformOrigin: 174.36,
                        MsTransformOrigin: 174.36,
                        transformOrigin: 174.36,
                    }}
                    id="elwi5b5do4hjs"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M184.57 215.42h-3.41l-.63 1.56h-2.32l3.55-8H184l3.57 8h-2.37zm-.67-1.68l-1-2.58-1 2.58z"
                    style={{
                        WebkitTransformOrigin: 182.89,
                        MsTransformOrigin: 182.89,
                        transformOrigin: 182.89,
                    }}
                    id="elw6mmiv3ovh"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M188.21 208.93h2.28v6.25h3.84V217h-6.12z"
                    style={{
                        WebkitTransformOrigin: 191.27,
                        MsTransformOrigin: 191.27,
                        transformOrigin: 191.27,
                    }}
                    id="el5v33jeqdoc"
                    fill="#FFF"
                    className="animable"
                ></path>
                <path
                    d="M195.23 208.93h2.28v6.25h3.84V217h-6.12z"
                    style={{
                        WebkitTransformOrigin: 198.29,
                        MsTransformOrigin: 198.29,
                        transformOrigin: 198.29,
                    }}
                    id="elwuqcrvv38w"
                    fill="#FFF"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--speech-bubble--inject-274"
                style={{
                    WebkitTransformOrigin: 406.715,
                    MsTransformOrigin: 406.715,
                    transformOrigin: 406.715,
                }}
                className="animable"
            >
                <path
                    style={{
                        WebkitTransformOrigin: 406.625,
                        MsTransformOrigin: 406.625,
                        transformOrigin: 406.625,
                    }}
                    id="elkbkso7w0w6"
                    fill="#FFF"
                    d="M405.05 85.38L384.77 70.52 382.18 95.01 356.39 97.71 376.2 117.51 361.04 131.96 382.51 133.54 385 152.81 401.99 138.46 425.01 152.81 431.44 129.06 456.86 125.49 434.58 109.64 446.59 88.54 427.25 92.96 421.81 67.01 405.05 85.38z"
                    className="animable"
                ></path>
                <path
                    d="M405.05 85.38l1.1-1.25c.74-.81 1.82-2 3.23-3.58l12.34-13.62.17-.19.05.25c1.5 7.11 3.36 15.89 5.48 25.94l-.21-.14 19.34-4.45.44-.1-.22.4-12 21.11-.07-.29 22.3 15.83.49.35-.6.09-25.41 3.58.21-.18-6.43 23.75-.09.34-.3-.19L407.12 142l-5.27-3.28h.31l-17 14.35-.36.3-.06-.47q-1.28-9.81-2.49-19.27l.23.22L361 132.2h-.55l.4-.38L376 117.35v.33l-19.75-19.82-.31-.31h.43l25.79-2.67-.16.12c1-9.58 1.91-17.72 2.64-24.5v-.21l.17.13 15 11.08 3.88 2.88 1.32 1s-.44-.3-1.32-.93l-3.9-2.82-15.14-11 .2-.09c-.7 6.78-1.55 14.92-2.54 24.5v.14h-.14l-25.77 2.73.12-.35 19.82 19.78.17.17-.18.16-15.14 14.46-.15-.42 21.47 1.57h.2v.21q1.22 9.44 2.5 19.27l-.42-.17 17-14.35.15-.12.16.1 5.26 3.28 17.76 11.07-.39.15c2.21-8.17 4.38-16.18 6.44-23.75v-.16h.17l25.41-3.56-.1.44-22.27-15.87-.16-.12.1-.17 12-21.09.22.3-19.35 4.4h-.17v-.18l-5.39-26 .22.06-12.43 13.66-3.26 3.52c-.73.8-1.11 1.18-1.11 1.18z"
                    style={{
                        WebkitTransformOrigin: 406.715,
                        MsTransformOrigin: 406.715,
                        transformOrigin: 406.715,
                    }}
                    id="elbt5fps7hhiv"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M401.82 94.42l-1.34 19.42a3.17 3.17 0 01-3 2.93 3.15 3.15 0 01-3.3-2.82l-2-19.54a2.47 2.47 0 012.51-2.73l4.73.09a2.48 2.48 0 012.4 2.65z"
                    style={{
                        WebkitTransformOrigin: 396.996,
                        MsTransformOrigin: 396.996,
                        transformOrigin: 396.996,
                    }}
                    id="elarn6ibms2vi"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M392.48 125.84a4.74 4.74 0 103-6 4.73 4.73 0 00-3 6z"
                    style={{
                        WebkitTransformOrigin: 396.975,
                        MsTransformOrigin: 396.975,
                        transformOrigin: 396.975,
                    }}
                    id="el13q67n61flr"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M417.88 94.42l-1.35 19.42a3.15 3.15 0 01-3 2.93 3.14 3.14 0 01-3.3-2.82l-2.05-19.54a2.47 2.47 0 012.51-2.73l4.74.09a2.48 2.48 0 012.45 2.65z"
                    style={{
                        WebkitTransformOrigin: 413.026,
                        MsTransformOrigin: 413.026,
                        transformOrigin: 413.026,
                    }}
                    id="elc4x1cc348e"
                    fill="#FF725E"
                    className="animable"
                ></path>
                <path
                    d="M408.53 125.84a4.74 4.74 0 103-6 4.75 4.75 0 00-3 6z"
                    style={{
                        WebkitTransformOrigin: 413.027,
                        MsTransformOrigin: 413.027,
                        transformOrigin: 413.027,
                    }}
                    id="elza2gxjembar"
                    fill="#FF725E"
                    className="animable"
                ></path>
            </g>
            <g
                id="freepik--Character--inject-274"
                style={{
                    WebkitTransformOrigin: 318.963,
                    MsTransformOrigin: 318.963,
                    transformOrigin: 318.963,
                }}
                className="animable"
            >
                <path
                    d="M392.1 338.55a5.82 5.82 0 00-2.77-4.6c-24.59-16.28-43.13-52.36-45-82.91-.05-1.74-.1-3.5-.16-5.28-1.54-45.93-8-98.8-13.63-110.77-12.05-25.47-46.78-28.53-46.78-28.53-47.95-3.43-56.51 33.42-61.35 67-3 20.87-14.61 95.42-14.61 95.42l8.81 3.41c10.39 30.71 33.76 55.6 64.15 67.04 8.84 3.33 16.33 4.67 19.84 1.81a120.65 120.65 0 0050.45 30.63c7.75 2.35 15.86 3.93 23.92 3.17 5.24-.49 10.76-2.22 13.88-6.45a12 12 0 00-10.32-19.14c1.82-5.9 13.78-4.16 13.57-10.8z"
                    style={{
                        WebkitTransformOrigin: 299.951,
                        MsTransformOrigin: 299.951,
                        transformOrigin: 299.951,
                    }}
                    id="el7f39kgu5adw"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M300.89 247.86s17.53-7.53 26.58-9.24 72.29-18 72.29-18l-65.27-55.93 14.4-17.52s48.48 28.93 82.95 52a4.86 4.86 0 01.65.44c19.6 15.43 12.74 42.31-7.39 54.94-10 6.29-54 25.24-62.47 29.39-17 8.28-16.75 8-16.75 8z"
                    style={{
                        WebkitTransformOrigin: 372.527,
                        MsTransformOrigin: 372.527,
                        transformOrigin: 372.527,
                    }}
                    id="el18s1wqivftd"
                    fill="#FFBF9D"
                    className="animable"
                ></path>
                <path
                    d="M290.14 120l-3-2.86-32.42 13.06a9 9 0 00-8.54 8.76l.28 105.62c0 7.17 1.39 13.37 5.72 19.08l4.55 6c10.38 13.71 31.74 12.58 40-2.52a11.59 11.59 0 001.14-2.73 19.92 19.92 0 00.48-2.37c1-8.49 1-15.86 1-15.86.58-9.33.77-13.16.77-13.07s19.86-2.29 25.23-27.77c2.67-12.68 2.16-30.12 1.41-47.28-1.06-23.73-17.53-38.06-36.62-38.06z"
                    style={{
                        WebkitTransformOrigin: 286.77,
                        MsTransformOrigin: 286.77,
                        transformOrigin: 286.77,
                    }}
                    id="ellyk2vm6oz3e"
                    fill="#FFBF9D"
                    className="animable"
                ></path>
                <path
                    d="M288.13 175a3.29 3.29 0 01-3.34 3.16 3.16 3.16 0 01-3.25-3.14 3.31 3.31 0 013.34-3.17 3.16 3.16 0 013.25 3.15z"
                    style={{
                        WebkitTransformOrigin: 284.835,
                        MsTransformOrigin: 284.835,
                        transformOrigin: 284.835,
                    }}
                    id="elqa4n0nwayca"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M320.3 175.94a3.3 3.3 0 01-3.35 3.17 3.16 3.16 0 01-3.24-3.14 3.29 3.29 0 013.34-3.17 3.16 3.16 0 013.25 3.14z"
                    style={{
                        WebkitTransformOrigin: 317.005,
                        MsTransformOrigin: 317.005,
                        transformOrigin: 317.005,
                    }}
                    id="ellyqznzdl2so"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M323.35 164.87c-.43.41-2.83-1.56-6.38-1.73s-6.23 1.47-6.59 1c-.18-.2.27-1 1.45-1.73a9.05 9.05 0 015.3-1.34 8.69 8.69 0 015.05 1.91c1.05.91 1.38 1.71 1.17 1.89z"
                    style={{
                        WebkitTransformOrigin: 316.876,
                        MsTransformOrigin: 316.876,
                        transformOrigin: 316.876,
                    }}
                    id="elog4h7xhscto"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M287.37 165.24c-.47.36-2.66-1.85-6.17-2.38s-6.35.83-6.66.34c-.16-.22.36-.93 1.62-1.57a9.09 9.09 0 015.41-.8 8.67 8.67 0 014.83 2.43c.95.99 1.2 1.82.97 1.98z"
                    style={{
                        WebkitTransformOrigin: 280.981,
                        MsTransformOrigin: 280.981,
                        transformOrigin: 280.981,
                    }}
                    id="el3nnx0yl8bwc"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M299.76 191.05c0-.21 2.21-.48 5.81-.75.91-.05 1.77-.19 2-.8a4.7 4.7 0 00-.47-2.71l-2.33-7c-3.23-10-5.52-18.21-5.11-18.33s3.34 7.87 6.57 17.88q1.15 3.69 2.22 7.06c.29 1 .82 2.24.29 3.58a2.3 2.3 0 01-1.56 1.25 6.3 6.3 0 01-1.55.13c-3.63-.02-5.87-.11-5.87-.31z"
                    style={{
                        WebkitTransformOrigin: 304.289,
                        MsTransformOrigin: 304.289,
                        transformOrigin: 304.289,
                    }}
                    id="el0onkt7ehzuyq"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M300.1 233.13a65.47 65.47 0 01-33.94-10.91s7.76 18.22 33.59 17.11z"
                    style={{
                        WebkitTransformOrigin: 283.13,
                        MsTransformOrigin: 283.13,
                        transformOrigin: 283.13,
                    }}
                    id="el9k7alcqqt9u"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M274.86 151.43c.13-1 3.68-1.36 7.63-2.78s7-3.28 7.71-2.56c.33.35 0 1.36-1.15 2.58a14.14 14.14 0 01-11.69 4.07c-1.62-.26-2.54-.83-2.5-1.31z"
                    style={{
                        WebkitTransformOrigin: 282.59,
                        MsTransformOrigin: 282.59,
                        transformOrigin: 282.59,
                    }}
                    id="el45fvvdvf5sc"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M321 151.4c-.67.77-3.07-.19-6-.38s-5.46.27-6-.6c-.23-.42.21-1.21 1.33-1.91a8.68 8.68 0 019.65.78c1.02.88 1.28 1.71 1.02 2.11z"
                    style={{
                        WebkitTransformOrigin: 315.017,
                        MsTransformOrigin: 315.017,
                        transformOrigin: 315.017,
                    }}
                    id="elixjlukwrbs"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M246.82 184.05s18.16 5.65 28.44-39.17c3.51-15.32 17.72-27.73 17.72-27.73l-5.76-1.74S251.41 125.5 250.8 126s-9 18.52-9 18.52z"
                    style={{
                        WebkitTransformOrigin: 267.39,
                        MsTransformOrigin: 267.39,
                        transformOrigin: 267.39,
                    }}
                    id="el9qskksmon9h"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M251.3 182.38c.09-1.91-1.9-6.54-3.77-6.93-5-1-14.12-1.09-14.85 11.72-1 17.51 16.79 14.9 16.85 14.4S251 189 251.3 182.38z"
                    style={{
                        WebkitTransformOrigin: 241.971,
                        MsTransformOrigin: 241.971,
                        transformOrigin: 241.971,
                    }}
                    id="el5z3c2cxl74u"
                    fill="#FFBF9D"
                    className="animable"
                ></path>
                <path
                    d="M244.56 194.63c-.07-.06-.32.2-.85.41a3 3 0 01-2.28-.09c-1.81-.78-3.2-3.81-3.11-7a10.29 10.29 0 011.1-4.32 3.53 3.53 0 012.43-2.21 1.55 1.55 0 011.75.94c.21.5.08.85.17.88s.39-.27.29-1a2 2 0 00-.62-1.14 2.35 2.35 0 00-1.67-.54 4.31 4.31 0 00-3.34 2.53 10.42 10.42 0 00-1.33 4.91c-.09 3.53 1.53 6.93 4 7.81a3.27 3.27 0 002.82-.31c.58-.45.7-.83.64-.87z"
                    style={{
                        WebkitTransformOrigin: 240.835,
                        MsTransformOrigin: 240.835,
                        transformOrigin: 240.835,
                    }}
                    id="elg24flfbtyvb"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M259.14 175.48c0-.06 1-.07 2.62-.53a15.81 15.81 0 006.24-3.62 21.85 21.85 0 003.25-3.81 30 30 0 002.65-5.12 110.56 110.56 0 003.77-12.73 132 132 0 014-12.72 72.2 72.2 0 014.56-9.89 53.29 53.29 0 014-6.16c.52-.69 1-1.19 1.26-1.55a3 3 0 01.46-.51 4.33 4.33 0 01-.39.57c-.26.37-.69.89-1.18 1.6a59.59 59.59 0 00-3.87 6.21 75.78 75.78 0 00-4.45 9.88c-1.44 3.83-2.75 8.13-4 12.69a105.72 105.72 0 01-3.83 12.77 28.29 28.29 0 01-2.72 5.17 21.36 21.36 0 01-3.35 3.84 15.41 15.41 0 01-6.41 3.55 9.85 9.85 0 01-2.61.36z"
                    style={{
                        WebkitTransformOrigin: 275.545,
                        MsTransformOrigin: 275.545,
                        transformOrigin: 275.545,
                    }}
                    id="ely1go0q99yc"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M235.21 250.19a3.9 3.9 0 01-.19-.84c-.11-.62-.26-1.44-.45-2.49l-1.57-9.51.42-.06c.09.64.19 1.34.29 2.07v-.07l.37.79-.44.16a168.34 168.34 0 01-5.64-28.19 173.19 173.19 0 01-1.07-18.23c.06-6.4 0-13.2 1.73-20a31.73 31.73 0 013.19-8 43.18 43.18 0 014.84-6.75c3.56-4.11 7.4-7.65 10.9-11.16l18.8-18.5c5.34-5.21 9.68-9.44 12.72-12.42l3.49-3.34.92-.86a1.5 1.5 0 01.34-.27 2.06 2.06 0 01-.28.33l-.86.91-3.39 3.45-12.54 12.61-18.68 18.61c-3.49 3.53-7.32 7.09-10.82 11.15a34.4 34.4 0 00-7.85 14.42c-1.68 6.64-1.66 13.41-1.73 19.78a175.94 175.94 0 006.36 46.3l-.44.16c-.12-.27-.25-.55-.35-.79-.09-.73-.18-1.44-.26-2.07l.42-.07c.59 4.08 1.05 7.29 1.38 9.54.14 1.06.25 1.89.33 2.51a5.08 5.08 0 01.06.83z"
                    style={{
                        WebkitTransformOrigin: 255.395,
                        MsTransformOrigin: 255.395,
                        transformOrigin: 255.395,
                    }}
                    id="elsykh55iuf9j"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M221.42 169.24a2.64 2.64 0 01.31-.74l1-2.06c.89-1.78 2.29-4.31 4.12-7.36s4.17-6.61 6.93-10.44 6-7.86 9.65-11.92 7.35-7.69 10.84-10.87 6.78-5.86 9.64-8 5.2-3.81 6.88-4.88l1.94-1.24a3.26 3.26 0 01.7-.38 3.24 3.24 0 01-.61.52l-1.82 1.35c-1.62 1.15-3.93 2.88-6.72 5.08s-6 4.93-9.49 8.09-7.1 6.84-10.73 10.86-6.84 8.07-9.66 11.83-5.16 7.28-7 10.29-3.36 5.48-4.33 7.22l-1.15 2a3.41 3.41 0 01-.5.65z"
                    style={{
                        WebkitTransformOrigin: 247.425,
                        MsTransformOrigin: 247.425,
                        transformOrigin: 247.425,
                    }}
                    id="el7tuvy1zo5lk"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M245.66 244.59h-.07z"
                    style={{
                        WebkitTransformOrigin: 245.625,
                        MsTransformOrigin: 245.625,
                        transformOrigin: 245.625,
                    }}
                    id="eldolmzhca8ae"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M245.59 244.57l-.18-.06z"
                    style={{
                        WebkitTransformOrigin: 245.5,
                        MsTransformOrigin: 245.5,
                        transformOrigin: 245.5,
                    }}
                    id="elf6nrdyiogsk"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M377.3 466l-25.11-76.52-2-72.72c-.61-12.54-1.54-30.88-1.54-30.88-8.19-25.62-34.23-47.25-34.23-47.25l-14.78 2.21c-.56 16-25 30.51-42.52 19.91-6.49-4.66-11.48-16.12-11.48-16.12L215.83 259l20.48 146.37s-20.2 37.69-20.2 60.57z"
                    style={{
                        WebkitTransformOrigin: 296.565,
                        MsTransformOrigin: 296.565,
                        transformOrigin: 296.565,
                    }}
                    id="elh2dcm41pq0n"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M245.41 244.51h-.17z"
                    style={{
                        WebkitTransformOrigin: 245.325,
                        MsTransformOrigin: 245.325,
                        transformOrigin: 245.325,
                    }}
                    id="elebwlgspv48h"
                    fill="#455A64"
                    className="animable"
                ></path>
                <g
                    style={{
                        WebkitTransformOrigin: 265.38,
                        MsTransformOrigin: 265.38,
                        transformOrigin: 265.38,
                    }}
                    id="elm7g5xkjw6h"
                    className="animable"
                    opacity="0.3"
                >
                    <path
                        id="elanjoy6cz8c"
                        d="M234.31 387.93c3.67 9.36 10.88 17.6 20.31 21.08s21 1.51 27.8-5.91c4.17-4.55 6.25-10.63 7.58-16.66a161.18 161.18 0 002.44-16.08c3.16-27.38 5.46-55 2.93-82.47l-3.74-31.68-10.82 6.1-5 112.82z"
                        style={{
                            WebkitTransformOrigin: 265.38,
                            MsTransformOrigin: 265.38,
                            transformOrigin: 265.38,
                        }}
                        className="animable"
                    ></path>
                </g>
                <path
                    d="M300 240.23s21.73-5.46 39.4-5.93l29.31-7.4 5 52.36-27.99 17.94z"
                    style={{
                        WebkitTransformOrigin: 336.855,
                        MsTransformOrigin: 336.855,
                        transformOrigin: 336.855,
                    }}
                    id="eldyphlkt1uul"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M248.26 320.74l-51.45 25.82S182.56 270.2 215.68 259l1.92 10.84z"
                    style={{
                        WebkitTransformOrigin: 221.011,
                        MsTransformOrigin: 221.011,
                        transformOrigin: 221.011,
                    }}
                    id="ele0u035m4rqj"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M347.05 255.05v.34c0 .22.05.6.08 1 .06.93.15 2.24.25 3.91.22 3.4.48 8.32.79 14.39.61 12.16 1.33 29 2 47.51s1.21 35.37 1.55 47.53c.15 6.06.28 11 .36 14.41 0 1.67.06 3 .07 3.92v1a1.23 1.23 0 010 .34 1.44 1.44 0 010-.34q0-.39-.06-1c0-.93-.1-2.24-.17-3.92-.13-3.43-.31-8.34-.53-14.4-.44-12.19-1-29-1.7-47.52s-1.38-35.32-1.85-47.51c-.27-6.06-.48-11-.63-14.4-.07-1.67-.12-3-.16-3.91v-1a1.18 1.18 0 010-.35z"
                    style={{
                        WebkitTransformOrigin: 349.599,
                        MsTransformOrigin: 349.599,
                        transformOrigin: 349.599,
                    }}
                    id="elwbdcdkjeq4"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M196.81 346.56s.06-.05.2-.13l.63-.35 2.44-1.28 9-4.61 29.83-15.06 6.26-3.13-.13.32a67.26 67.26 0 00-3.12-7.64c-1.15-2.42-2-4.82-2.91-7.08-1.7-4.53-3.47-8.47-4.91-11.78s-2.58-6-3.31-7.82c-.36-.93-.64-1.65-.81-2.15a4.91 4.91 0 01-.24-.75 5 5 0 01.33.72l.89 2.1c.79 1.84 2 4.48 3.45 7.76s3.29 7.23 5 11.76c.88 2.25 1.79 4.64 2.94 7a68.7 68.7 0 013.15 7.67l.09.22-.21.11-6.25 3.14-29.91 14.92-9.05 4.5-2.48 1.2-.65.29a.76.76 0 01-.23.07z"
                    style={{
                        WebkitTransformOrigin: 221.2,
                        MsTransformOrigin: 221.2,
                        transformOrigin: 221.2,
                    }}
                    id="eljv4b5eg3wws"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M303.92 199.65a13.71 13.71 0 00-6.7-2.4 4.94 4.94 0 00-2.23.23 4 4 0 00-2.12 2.55 12 12 0 00-.38 3.39 2.72 2.72 0 00.2 1.27 2.44 2.44 0 002.07 1 15.42 15.42 0 007.91-1.45"
                    style={{
                        WebkitTransformOrigin: 298.2,
                        MsTransformOrigin: 298.2,
                        transformOrigin: 298.2,
                    }}
                    id="eltg768869ogm"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M203.35 343.27c10.52 24.44 30.51 49.25 42.83 53.79 18.35 6.76 33.54 3.4 40.58-19s2.52-121.8 2.52-121.8l-30.6-1.75-5.68 85.67s-3.38-6.65-9.33-17.14"
                    style={{
                        WebkitTransformOrigin: 247.029,
                        MsTransformOrigin: 247.029,
                        transformOrigin: 247.029,
                    }}
                    id="elybzkzeqmmtq"
                    fill="#FFBF9D"
                    className="animable"
                ></path>
                <path
                    d="M334.49 164.68l-7.71-5.62-1.18-9.66s-13.92.36-14.77-7.1c0 0-8 2.13-7.64-5.76 0 0-4.08-2.77-2.59-5.32s13-6.37 13.66-6.58 8.18-1.81 8.18-1.81l-2.23-2.48-6 .64s-3.62 3.41-6.61 3.83-3.19-.85-3.19-.85-3.41-3.62 1.06-7.25a25.36 25.36 0 0113.21-5.11c3-.21 7 5.54 7 5.54l3.24 5.75s6.4-.85 8.53 4v3.41s4.69-.64 6.61 4.91l1.28 4.9s5.54 7.24 5.75 10.23"
                    style={{
                        WebkitTransformOrigin: 325.681,
                        MsTransformOrigin: 325.681,
                        transformOrigin: 325.681,
                    }}
                    id="elgh6bb9ejsnc"
                    fill="#FFBF9D"
                    className="animable"
                ></path>
                <path
                    d="M351.11 150.4s-.05-.27-.18-.76a13.22 13.22 0 00-.88-2.1 54.71 54.71 0 00-4.8-7.29v-.05c-.39-1.46-.83-3.12-1.3-4.9a7.68 7.68 0 00-2.23-3.42 5.88 5.88 0 00-4.21-1.35h-.2v-.2-3.41.08a6.23 6.23 0 00-3.3-3.22 10.42 10.42 0 00-5-.69h-.14l-.07-.12-3.26-5.75a25.13 25.13 0 00-2.32-2.78 11.51 11.51 0 00-2.88-2.27 3.36 3.36 0 00-1.73-.37c-.63 0-1.26.15-1.9.25a27.51 27.51 0 00-3.8 1 22.89 22.89 0 00-7.1 3.75 5.84 5.84 0 00-2.26 3.23 4.54 4.54 0 001.1 3.73h.05v.09a1.11 1.11 0 00.79.59 4 4 0 001.22.13 6.65 6.65 0 002.51-.57 18.53 18.53 0 004.51-3l.34-.31.07-.06h.08l6-.64h.13l.09.1 2.23 2.49.3.33-.44.1-7.75 1.71a73.36 73.36 0 00-7.22 2.62c-1.16.48-2.29 1-3.39 1.55a12.15 12.15 0 00-3 1.95 2.22 2.22 0 00-.62 1.45 3 3 0 00.46 1.56 8.84 8.84 0 002.34 2.42l.1.07v.14c0 .49 0 1 .05 1.47a6 6 0 00.32 1.41 3.87 3.87 0 001.68 2.14 7.44 7.44 0 005.3.51l.2-.01v.23a5.79 5.79 0 002.38 4 12.55 12.55 0 004.09 1.93 29.72 29.72 0 008.09 1.06h.15v.14c.45 3.83.83 7 1.14 9.67v-.08l5.7 4.22 1.46 1.1.48.39-.52-.34-1.49-1.05-5.76-4.14v-.06c-.34-2.64-.74-5.83-1.23-9.65l.17.14a29.75 29.75 0 01-8.21-1 12.87 12.87 0 01-4.22-2 6.14 6.14 0 01-2.56-4.24l.26.18a9.83 9.83 0 01-2.82.26 6.22 6.22 0 01-2.82-.8 4.35 4.35 0 01-1.88-2.37 6.5 6.5 0 01-.35-1.51c-.06-.51 0-1-.05-1.55l.1.21a8.94 8.94 0 01-2.48-2.57 3.52 3.52 0 01-.54-1.81 2.67 2.67 0 01.76-1.78 12.79 12.79 0 013.11-2.05c1.11-.57 2.25-1.09 3.42-1.57a75 75 0 017.25-2.65l7.81-1.73-.14.43-2.3-2.49.22.09-6 .64.15-.07-.36.32a18.94 18.94 0 01-4.64 3.06 7.07 7.07 0 01-2.7.6 4.4 4.4 0 01-1.39-.15 1.53 1.53 0 01-1.15-1l.07.14A5 5 0 01303 120a5.46 5.46 0 01.92-2c.24-.28.46-.56.72-.82s.52-.49.8-.71a23.51 23.51 0 017.27-3.82 28.13 28.13 0 013.87-1c.65-.1 1.29-.2 1.95-.25a3.89 3.89 0 012 .42 12.14 12.14 0 013 2.37 26.42 26.42 0 012.36 2.85l3.23 5.77-.21-.11a10.67 10.67 0 015.23.75 6.58 6.58 0 013.5 3.44v3.52l-.2-.18a6.23 6.23 0 014.47 1.47 8.1 8.1 0 012.3 3.57c.46 1.78.88 3.44 1.26 4.9a51.24 51.24 0 014.71 7.39 12.18 12.18 0 01.83 2.14 4.15 4.15 0 01.1.7z"
                    style={{
                        WebkitTransformOrigin: 325.6,
                        MsTransformOrigin: 325.6,
                        transformOrigin: 325.6,
                    }}
                    id="elt7jcvvdgal"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M337.4 154.32c-.06.05-.57-.47-1.52-1.16a17.2 17.2 0 00-4-2.12 35.12 35.12 0 00-4.4-1.35c-1.15-.21-1.89-.19-1.9-.28a4.42 4.42 0 011.95-.08 22.68 22.68 0 014.53 1.22 13.86 13.86 0 014.09 2.32 4.3 4.3 0 011.25 1.45z"
                    style={{
                        WebkitTransformOrigin: 331.49,
                        MsTransformOrigin: 331.49,
                        transformOrigin: 331.49,
                    }}
                    id="el7harau97aro"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M339.66 140.29a4.51 4.51 0 01-1.16.14l-3.16.18c-2.67.13-6.36.27-10.43.4l-5.75.15a41 41 0 00-4.65.27 18.36 18.36 0 00-3.08.6c-.7.22-1.07.41-1.09.37a2.93 2.93 0 011-.56 15 15 0 013.08-.78 38 38 0 014.7-.38l5.75-.2c4.07-.12 7.76-.2 10.43-.24h3.16a6.06 6.06 0 011.2.05z"
                    style={{
                        WebkitTransformOrigin: 325,
                        MsTransformOrigin: 325,
                        transformOrigin: 325,
                    }}
                    id="el9dll562b4aw"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M333.24 131.32a4.79 4.79 0 01-1.17.24l-3.21.48c-2.72.4-6.46 1-10.57 1.75s-7.82 1.55-10.5 2.14l-3.17.7a5.81 5.81 0 01-1.18.2 4.6 4.6 0 011.13-.4c.73-.22 1.81-.51 3.14-.86 2.66-.68 6.36-1.53 10.48-2.3s7.89-1.29 10.62-1.59c1.36-.16 2.47-.27 3.24-.32a5.66 5.66 0 011.19-.04z"
                    style={{
                        WebkitTransformOrigin: 318.34,
                        MsTransformOrigin: 318.34,
                        transformOrigin: 318.34,
                    }}
                    id="elag8ihkcs9rp"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M320.58 116.61c.13 0 .5.79.44 1.9s-.5 1.91-.63 1.85.07-.87.11-1.88-.07-1.83.08-1.87z"
                    style={{
                        WebkitTransformOrigin: 320.687,
                        MsTransformOrigin: 320.687,
                        transformOrigin: 320.687,
                    }}
                    id="ell4vjx5354rp"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M225.51 184.08C234 195.28 256 227.71 265 239.31c1.89 2.45 7.4 1.55 9.83-.37 5.78-4.54 15.9-12.44 21.94-16.78a5.55 5.55 0 001.16-7.91L255 158.5a5.56 5.56 0 00-8.16-.71l-20.62 18.83a5.57 5.57 0 00-.71 7.46z"
                    style={{
                        WebkitTransformOrigin: 261.744,
                        MsTransformOrigin: 261.744,
                        transformOrigin: 261.744,
                    }}
                    id="elktrpq1wxefp"
                    fill="#455A64"
                    className="animable"
                ></path>
                <path
                    d="M257.9 353.34l-4.9-13.16 5.66-85.65S247.4 234 246.14 229.45s-1.57-17.6-1.57-17.6l7.89 9.15s.22-15.73.22-21c0 0 1.12-19.77 1.31-22.52s3-4.21 4.77-4.21 3.53 3.26 3.53 3.26l2.41 32.35s4-17 5.48-19.27 6.71-3.33 10.22-3.08h.1a3 3 0 011.37 5.38l-4.63 3.24-1.75 16.23s4.26-14 6.52-15.81 6.27 0 7 2-2 6-2 6l-.76 10s3-4.26 4.49-6.52 5.3 0 5.76 1-2.7 11.95-2.7 11.95l-4.52 36.33 1.43 52.31"
                    style={{
                        WebkitTransformOrigin: 270.558,
                        MsTransformOrigin: 270.558,
                        transformOrigin: 270.558,
                    }}
                    id="elm18ehckpcn"
                    fill="#FFBF9D"
                    className="animable"
                ></path>
                <path
                    d="M290.71 308.59v-.9c0-.6-.05-1.5-.1-2.66-.07-2.35-.18-5.81-.32-10.3-.26-9-.64-22.06-1.12-38.44 1.32-10.74 2.83-22.93 4.48-36.33.59-2 1.16-4.08 1.69-6.18.27-1.05.53-2.11.75-3.18.11-.54.21-1.08.28-1.62a2.79 2.79 0 000-.71 2.49 2.49 0 00-.49-.56 5.52 5.52 0 00-2.93-1.26 2.14 2.14 0 00-1.47.36 5.12 5.12 0 00-1 1.27l-4 5.75-.47.69.06-.83c.23-3.11.49-6.55.75-10v-.11a16.6 16.6 0 001.73-3.35 5.18 5.18 0 00.35-1.8 2.26 2.26 0 00-.72-1.57 5.74 5.74 0 00-3.32-1.62 3.23 3.23 0 00-3.27 1.27 21.61 21.61 0 00-1.81 3.52c-.51 1.23-1 2.48-1.47 3.76-.93 2.54-1.79 5.14-2.61 7.77l-.48-.1c.55-5.1 1.15-10.62 1.75-16.22V195l.1-.06 4.38-3.07a2.84 2.84 0 001.38-2 2.81 2.81 0 00-.69-2.3 2.88 2.88 0 00-2.27-.86 18.5 18.5 0 00-2.68.12 15.09 15.09 0 00-5.16 1.48 4.12 4.12 0 00-1.85 1.77 20.34 20.34 0 00-1 2.55c-.56 1.75-1.07 3.54-1.55 5.34q-1.45 5.4-2.74 10.92l-.39 1.63-.13-1.67c-.32-4.36-.67-9-1-13.75q-.71-9.39-1.39-18.6v.11a8.74 8.74 0 00-2.18-2.7c-.88-.74-2.1-.39-3.12.09a4.45 4.45 0 00-2.27 2.39 5 5 0 00-.27 1.67l-.11 1.78q-.41 7.08-.82 14c-.12 2.31-.31 4.61-.37 6.89s0 4.56-.07 6.83l-.14 13.38v.66l-.43-.5-7.81-9.1.42-.17c.12 4.06.32 8.07.7 12a34.66 34.66 0 00.92 5.75 50.18 50.18 0 002.26 5.28c3.32 6.86 6.81 13.36 10.18 19.57v.06c-2.68 39.51-4.73 69.79-5.8 85.65 1.61 4.41 2.82 7.7 3.63 9.9.39 1.09.69 1.91.89 2.46s.28.83.28.83l-.32-.81-.93-2.45c-.83-2.19-2.06-5.47-3.72-9.87 1-15.86 3-46.15 5.54-85.66v.11c-3.38-6.21-6.88-12.7-10.22-19.58a48.18 48.18 0 01-2.29-5.34 33.6 33.6 0 01-1-5.83c-.39-3.94-.59-7.95-.71-12v-.68l.45.52 7.89 9.15-.44.16.14-13.4q0-3.39.07-6.82c.05-2.29.24-4.59.36-6.9q.41-6.94.82-14l.1-1.77a5.83 5.83 0 01.3-1.82 5.06 5.06 0 012.53-2.68 5.82 5.82 0 011.79-.55 2.41 2.41 0 011 .07 3.09 3.09 0 01.87.44 9.36 9.36 0 012.34 2.87v.11q.69 9.19 1.39 18.59c.35 4.71.7 9.39 1 13.75h-.51q1.31-5.52 2.75-10.94c.48-1.8 1-3.59 1.56-5.36a20.47 20.47 0 011-2.63 4.61 4.61 0 012.07-2 15.08 15.08 0 015.34-1.53 18.1 18.1 0 012.76-.13 3.37 3.37 0 012.63 1 3.25 3.25 0 01.26 4.06 4 4 0 01-1 1l-4.38 3.06.1-.18c-.6 5.61-1.2 11.13-1.76 16.22l-.48-.1q1.23-4 2.62-7.79c.47-1.28 1-2.54 1.49-3.78a22 22 0 011.86-3.61 3.77 3.77 0 01.72-.78 4 4 0 01.94-.5 4.66 4.66 0 012.06-.18 6.3 6.3 0 013.61 1.76 2.82 2.82 0 01.84 1.89 5.85 5.85 0 01-.38 2 16.6 16.6 0 01-1.79 3.45v-.11c-.27 3.49-.53 6.93-.76 10l-.41-.15 4-5.73.49-.71a2.74 2.74 0 01.64-.68 2.59 2.59 0 011.76-.44 6 6 0 013.18 1.38 2.44 2.44 0 01.6.7 2.52 2.52 0 010 .94c-.07.56-.17 1.11-.28 1.65-.23 1.09-.49 2.15-.76 3.21-.54 2.1-1.12 4.16-1.7 6.18-1.68 13.4-3.21 25.59-4.55 36.33.41 16.39.74 29.46 1 38.45.1 4.48.18 7.94.23 10.3 0 1.16 0 2.05.05 2.66s.08.74.08.74z"
                    style={{
                        WebkitTransformOrigin: 270.452,
                        MsTransformOrigin: 270.452,
                        transformOrigin: 270.452,
                    }}
                    id="el7yduvd268bg"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M253 239.31a22.15 22.15 0 01-.29-3.55c-.11-2.2-.22-5.23-.31-8.59s-.15-6.39-.17-8.59a24.54 24.54 0 01.09-3.56 25 25 0 01.28 3.55c.11 2.2.22 5.23.32 8.59s.15 6.39.16 8.59a25.7 25.7 0 01-.08 3.56z"
                    style={{
                        WebkitTransformOrigin: 252.655,
                        MsTransformOrigin: 252.655,
                        transformOrigin: 252.655,
                    }}
                    id="elsftsuo9eea"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
                <path
                    d="M302.67 204.21a3.56 3.56 0 01-1 .53 13.52 13.52 0 01-2.9.91 14.84 14.84 0 01-4.52.2 3 3 0 01-1.31-.49 1.76 1.76 0 01-.71-1.33 17.67 17.67 0 01.11-2.89 5.66 5.66 0 011.06-2.73 3.48 3.48 0 012.4-1.41 11.63 11.63 0 014.49.65A12.08 12.08 0 01303 199a3.4 3.4 0 01.88.68 22.48 22.48 0 00-3.74-1.63 12 12 0 00-4.31-.52 3 3 0 00-2.05 1.22 5.19 5.19 0 00-.94 2.5 18.63 18.63 0 00-.12 2.77c0 .86.79 1.27 1.59 1.38a15.36 15.36 0 004.38-.08 30.08 30.08 0 003.98-1.11z"
                    style={{
                        WebkitTransformOrigin: 298.047,
                        MsTransformOrigin: 298.047,
                        transformOrigin: 298.047,
                    }}
                    id="elud36zti0x6"
                    fill="#263238"
                    className="animable"
                ></path>
                <path
                    d="M417.38 226a10.49 10.49 0 01-2.71 0 30.81 30.81 0 01-12.49-3.59 10.05 10.05 0 01-2.27-1.47 21 21 0 012.43 1.14 40.67 40.67 0 006 2.29 39.48 39.48 0 006.32 1.26 23.27 23.27 0 012.72.37z"
                    style={{
                        WebkitTransformOrigin: 408.645,
                        MsTransformOrigin: 408.645,
                        transformOrigin: 408.645,
                    }}
                    id="elj19bqzftqtc"
                    fill="#FF9A6C"
                    className="animable"
                ></path>
            </g>
            <defs>
                <filter id="active" height="200%">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius="2"
                        result="DILATED"
                    ></feMorphology>
                    <feFlood
                        floodColor="#32DFEC"
                        floodOpacity="1"
                        result="PINK"
                    ></feFlood>
                    <feComposite
                        in="PINK"
                        in2="DILATED"
                        operator="in"
                        result="OUTLINE"
                    ></feComposite>
                    <feMerge>
                        <feMergeNode in="OUTLINE"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
                <filter id="hover" height="200%">
                    <feMorphology
                        in="SourceAlpha"
                        operator="dilate"
                        radius="2"
                        result="DILATED"
                    ></feMorphology>
                    <feFlood floodColor="red" floodOpacity="0.5" result="PINK"></feFlood>
                    <feComposite
                        in="PINK"
                        in2="DILATED"
                        operator="in"
                        result="OUTLINE"
                    ></feComposite>
                    <feMerge>
                        <feMergeNode in="OUTLINE"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                    <feColorMatrix values="0 0 0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 1 0"></feColorMatrix>
                </filter>
            </defs>
        </svg>
    );
}
